import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { raceData } from '@/data/races';
import { Button } from '@/components/ui/button';
import { Mountain, TrendingUp, Zap } from 'lucide-react';

const cardVariants = {
    offscreen: { y: 50, opacity: 0 },
    onscreen: (i) => ({
        y: 0,
        opacity: 1,
        transition: {
            type: "spring",
            bounce: 0.4,
            duration: 0.8,
            delay: i * 0.1,
        }
    })
};

const RaceCard = ({ race, index }) => {
    return (
        <motion.div
            custom={index}
            variants={cardVariants}
            className={`bg-gradient-to-b ${race.bgClass} border ${race.borderColor} rounded-xl shadow-lg p-8 flex flex-col h-full`}
        >
            <h3 className="text-3xl font-black uppercase text-foreground mb-2">{race.name}</h3>
            <div className="flex items-center space-x-6 text-muted-foreground mb-4">
                <div className="flex items-center space-x-2">
                    <Zap className="h-5 w-5 text-primary"/>
                    <span>{race.distance}</span>
                </div>
                <div className="flex items-center space-x-2">
                    <TrendingUp className="h-5 w-5 text-primary"/>
                    <span>{race.elevation}</span>
                </div>
            </div>
            <p className="text-foreground/80 flex-grow mb-6">{race.description}</p>
            <Button asChild variant="outline" className="mt-auto w-full">
                <Link to={`/race/${race.id}`}>Lihat Detail</Link>
            </Button>
        </motion.div>
    );
};

const RacesPage = () => {
  return (
    <>
      <Helmet>
        <title>Daftar Lomba - Banyumas Ultra</title>
        <meta name="description" content="Pilih tantangan lari trail Anda di Baturaden. Dari 7KM hingga 50KM, temukan jalur yang tepat untuk Anda." />
      </Helmet>
      <div className="bg-background pt-24 sm:pt-32">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-center mb-16"
          >
              <Mountain className="mx-auto h-12 w-12 text-primary mb-4" />
              <h1 className="text-4xl md:text-5xl font-black text-foreground">PILIH TANTANGANMU</h1>
              <p className="mt-4 max-w-3xl mx-auto text-lg text-muted-foreground">
                  Dari ultramaraton brutal hingga lari santai yang indah, kami punya jalur yang sempurna untuk setiap level pelari.
              </p>
          </motion.div>
          
          <motion.div 
              initial="offscreen"
              whileInView="onscreen"
              viewport={{ once: true, amount: 0.2 }}
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8"
          >
            {raceData.map((race, index) => (
              <RaceCard key={race.name} race={race} index={index} />
            ))}
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default RacesPage;